import React from 'react';
import './detailBoxLargeEmployee.css';
import { checkOrangeIcon, circleIcon } from '../../../../utils/icons';

const DetailBoxLargeEmployee = ({ title, data, checkedSkills }) => {
  // Mapping of display names to backend skill keys
  const skillMapping = {
    "Trabajo en equipo": "trabajoEnEquipo",
    "Responsabilidad": "responsabilidad", 
    "Puntualidad y compromiso": "puntualidad",
    "Habilidad para aprender": "habilidadParaAprender",
    "Atención al cliente": "atencionAlCliente",
    "Flexibilidad y adaptabilidad": "adaptabilidad",
    "Empatía": "empatía",
    "Proactividad": "proactividad",
    "Comunicación efectiva": "comunicaciónEfectiva",
    "Resolución de problemas": "resoluciónDeProblemas",
    "Organización": "organización",
    "Trabajo bajo presión": "trabajoBajoPresión",
    "Idiomas": "idiomas",
    "Manejo de software": "manejoDeSoftware"
  };

  // Filter out invalid skills (numeric strings) and ensure checkedSkills is an array
  const validCheckedSkills = Array.isArray(checkedSkills) 
    ? checkedSkills.filter(skill => skill && !/^\d+$/.test(skill.toString()))
    : [];

  return (
    <div className="box-large-employee__skills-container">
      <h3>{title}</h3>
      <ul className="detail-box-large-employee__grid-box-container">
        {data.map((value, index) => {
          const skillKey = skillMapping[value];
          const isSelected = skillKey && validCheckedSkills.includes(skillKey);
          
          return (
            <li key={index} className="detail-box-large-employee__icon-value-container">
              {isSelected ? checkOrangeIcon : circleIcon}
              <div className="detail-box-large-employee__value-container">
                {value}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default DetailBoxLargeEmployee;




